import { ARROW_LEFT, ARROW_RIGHT } from '../../keysConstants';

function getCharCodeFromEvent(event) {
  event = event || window.event;
  return (typeof event.which === 'undefined') ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
  return charStr === '.' || charStr === '-' || !isNaN(charStr);
}

function isKeyPressedNumeric(event) {
  const charCode = getCharCodeFromEvent(event);
  const charStr = String.fromCharCode(charCode);
  return isCharNumeric(charStr);
}

class NumericCellEditor {
  // gets called once before the renderer is used
  init(params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.className = 'ag-cell-edit-input';

    this.parseValue = params.parseValue;

    if (isCharNumeric(params.charPress)) {
      this.eInput.value = params.charPress;
    }

    if (params.value !== undefined && params.value !== null) { // eslint-disable-line no-undefined
      this.eInput.value = params.value;
    }

    this.eInput.addEventListener('keypress', event => {
      if (!isKeyPressedNumeric(event)) {
        this.eInput.focus();
        if (event.preventDefault) {
          event.preventDefault();
        }
      } else if (this.isKeyPressedNavigation(event)) {
        event.stopPropagation();
      }
    });

    // only start edit if key pressed is a number, not a letter
    const charPressIsNotANumber = params.charPress && ('1234567890.-'.indexOf(params.charPress) < 0);
    this.cancelBeforeStart = charPressIsNotANumber;
  }

  isKeyPressedNavigation = event => event.key === ARROW_LEFT || event.key === ARROW_RIGHT;

  // gets called once when grid ready to insert the element
  getGui() {
    return this.eInput;
  }

  // focus and select can be done after the gui is attached
  afterGuiAttached() {
    this.eInput.focus();
    this.eInput.select();
  }

  // returns the new value after editing
  isCancelBeforeStart() {
    return this.cancelBeforeStart;
  }

  getValue() {
    if (this.parseValue) {
      return this.parseValue(this.eInput.value);
    }
    return this.eInput.value;
  }
}

export default NumericCellEditor;
